import { render, staticRenderFns } from "./Destroy.vue?vue&type=template&id=76cf341a&scoped=true"
import script from "./Destroy.vue?vue&type=script&lang=js"
export * from "./Destroy.vue?vue&type=script&lang=js"
import style0 from "./Destroy.vue?vue&type=style&index=0&id=76cf341a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cf341a",
  null
  
)

export default component.exports